import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing available tacho icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <AvailableTachoIcon width={12} />
 */
export function AvailableTachoIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M5,5V43H43V5H5ZM9.87,9.88H34L9.87,34V9.88Zm2.72,28.26L38.12,12.6V38.13H12.59Z" />
        </SvgIcon>
    )
}

AvailableTachoIcon.defaultProps = defaultProps
